module.exports = __webpack_public_path__ + "static/media/logo-invterter.d9c31bab.svg";